import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { cfbhAxios } from "utilities/axios";

export const fetchApplications = createAsyncThunk(
  "applications/fetchApplications",
  async ({ search, page = 1, pageSize = 20 }) => {
    const params = { page, pageSize };
    if (search) params.search = search;

    var currentTime = new Date().getTime();
    const response = await cfbhAxios.get("/applications", { params });
    return {
      data: response.data.data,
      total: response.data.total,
      page: page,
      pageSize: pageSize,
      contentTime: currentTime,
      search: search || "",
    };
  }
);

const applicationsSlice = createSlice({
  name: "applications",
  initialState: {
    data: [],
    total: 0,
    page: 1,
    pageSize: 20,
    search: "",
    status: "idle",
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplications.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchApplications.fulfilled, (state, action) => {
        if (
          !state.contentTime ||
          action.payload.contentTime > state.contentTime
        ) {
          state.status = "succeeded";
          // If page === 1, replace; else, append
          if (action.payload.page === 1) {
            state.data = action.payload.data;
          } else {
            state.data = [...state.data, ...action.payload.data];
          }
          state.total = action.payload.total;
          state.page = action.payload.page;
          state.pageSize = action.payload.pageSize;
          state.contentTime = action.payload.contentTime;
        }
      })
      .addCase(fetchApplications.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default applicationsSlice.reducer;
